export const EMPLOYEES_CREATE_ROUTE_NAME = Symbol('personnel.create');
export const TRANSLATION_GROUP_EMPLOYEES_CREATE = Symbol('personnel.create');

export const EMPLOYEES_ROLES_LIST_QUERY_KEY = Symbol('personnel.roles.list');
export const EMPLOYEES_ROLES_LIST_API_URL = 'admin/personals/list_roles';

export const EMPLOYEES_CREATE_QUERY_KEY = Symbol('personnel.new');
export const EMPLOYEES_CREATE_API_URL = 'admin/personals';
